export enum ENV_URL {
  LOCAL = 'localhost',
  DEV = 'webappin',
  PRE_PROD = 'webapptn',
}
